import Select from "react-select";
import { eventTypesOptions, eventTypesWithoutVirtualOptions } from "../../../data/selectOptions";
import { multiEventTypeSelectStyles } from "../../../utils/reactSelectControlStyles.js";
import styles from "../../../styles/Reports.module.css";
import ReportFilterSection from "./ReportFilterSection.jsx";
import ReportYearSelect from "./ReportYearSelect.jsx";

const YearEventTypePanel = ({
  t,
  reportI18nKeys,
  yearOptions,
  selectedYear,
  selectedReportOption,
  selectedEventTypes,
  handlers,
  includeVirtualEventTypes,
}) => {
  const { onYearOptionChange, onEventTypesChange } = handlers;

  return (
  <ReportFilterSection t={t} reportI18nKeys={reportI18nKeys}>
    <ReportYearSelect
      t={t}
      reportI18nKeys={reportI18nKeys}
      yearOptions={yearOptions}
      selectedYear={selectedYear}
      onYearOptionChange={onYearOptionChange}
      isDisabled={!selectedReportOption}
    />
    <div className={styles.filterItemContent}>
      <label className={styles.label}>{t("pages.reports.eventType")}</label>
      <Select
        isMulti
        isClearable
        closeMenuOnSelect={false}
        options={
          includeVirtualEventTypes
            ? eventTypesOptions(t)
            : eventTypesWithoutVirtualOptions(t)
        }
        value={selectedEventTypes}
        onChange={onEventTypesChange}
        isDisabled={!selectedReportOption}
        placeholder={t("pages.reports.eventTypePlaceholder")}
        styles={multiEventTypeSelectStyles}
      />
    </div>
  </ReportFilterSection>
  );
};

export default YearEventTypePanel;
